import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withPlans } from "src/modules/plan/operations";

import { withStateAndActionsForPlan } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, plans, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"plans"}
            component={RenderSelect}
            placeholder={"Plans"}
            label={"Plans"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(plans?.map((plan) => ({
                    id: plan.id,
                    label: plan.name || "",
                    value: JSON.stringify(plan),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(withStateAndActionsForPlan, withPlans)(SubjectsField);
